import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import Styleguide from "@store/Framework/Types/Styleguide";
import ChevronDown from "@store/Library/Components/Icons/ChevronDown";
import ChevronsUpDown from "@store/Library/Components/Icons/ChevronsUpDown";
import ChevronUp from "@store/Library/Components/Icons/ChevronUp";
import { focusStyles } from "@store/Themes/common/mixins/common";
import { css } from "styled-components";

const baseCellStyles = () => css`
    height: auto;
    padding: ${pxToRem(16)};
    border: 0;
    text-align: left;
    line-height: ${x => x.theme.design.typography.lineHeight.small};
`;

const dataTable: Styleguide["dataTable"] = {
    defaultProps: {
        headerTypographyProps: {
            weight: "inherit",
            size: "inherit",
        },
        cellTypographyProps: {
            size: "inherit",
        },
        sortClickableProps: {
            css: css`
                ${focusStyles()}
                width: 100%;
                height: 100%;
                justify-content: space-between;
                color: inherit;

                &:hover {
                    text-decoration: underline;
                }
            `,
        },
        sortIconProps: {
            size: 16,
            css: css`
                color: inherit;
                margin-left: 0.5em;
            `,
        },
        sortIconSources: {
            sortable: ChevronsUpDown,
            ascending: ChevronUp,
            descending: ChevronDown,
        },
        /* Store Removed - css */
        cssOverrides: {
            header: css`
                ${baseCellStyles()}
                /* Store Custom Code - Start */
                background-color: ${getColor("primary.light")};
                /* Store Custom Code - End */
                color: ${getColor("primary.contrast")};
                font-weight: ${x => x.theme.design.typography.weight.bold};
            `,
            cell: css`
                ${baseCellStyles()}
                font-size: ${x => x.theme.design.typography.size.small};
                font-weight: inherit;
            `,
        },
    },
};

export default dataTable;
